import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const useBackendApi = Boolean(BACKEND_URL);
const API = useBackendApi ? `${BACKEND_URL}/api` : "";

const BranchContext = createContext();

export function BranchProvider({ children }) {
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [featuredItems, setFeaturedItems] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const selectBranch = (branchId) => {
    setSelectedBranch(branchId);
  };

  const hasBranchSelected = selectedBranch !== "";

  useEffect(() => {
    if (!useBackendApi) {
      setLoading(false);
      return;
    }
    const fetchBranches = async () => {
      try {
        const res = await axios.get(`${API}/branches`);
        setBranches(res.data);
      } catch (e) {
        console.error("Failed to fetch branches", e);
      }
    };
    fetchBranches();
  }, []);

  useEffect(() => {
    if (!selectedBranch) return;
    if (!useBackendApi) {
      setMenuItems([]);
      setFeaturedItems([]);
      setGalleryItems([]);
      setLoading(false);
      return;
    }
    const fetchData = async () => {
      setLoading(true);
      try {
        const [menuRes, featuredRes, galleryRes] = await Promise.all([
          axios.get(`${API}/menu/${selectedBranch}`),
          axios.get(`${API}/menu/${selectedBranch}/featured`),
          axios.get(`${API}/gallery/${selectedBranch}`),
        ]);
        setMenuItems(menuRes.data);
        setFeaturedItems(featuredRes.data);
        setGalleryItems(galleryRes.data);
      } catch (e) {
        console.error("Failed to fetch branch data", e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedBranch]);

  return (
    <BranchContext.Provider
      value={{
        selectedBranch,
        setSelectedBranch: selectBranch,
        hasBranchSelected,
        branches,
        menuItems,
        featuredItems,
        galleryItems,
        loading,
      }}
    >
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  const context = useContext(BranchContext);
  if (!context) throw new Error("useBranch must be used within BranchProvider");
  return context;
}
